import React from 'react'

import { Card, Typography, Paper, CardContent, Divider, Grid, Stack } from '@mui/material';

import Header from "../components/Header";
import Footer from "../components/Footer";
import SEO from '../components/SEO';

import { Box } from '@mui/system';
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import * as Constants from '../constants/services'
export default function Services() {

    const style = {
        background: {
            paddingLeft: 2,
            paddingRight: 2,
            borderRadius: 0,
            paddingBottom: 0,
            paddingTop: 5,
            '@media only screen and (max-width: 900px)': {
                paddingTop: 2
            }
        },
        iconCenter: {
            width: 100,
            height: 100,
            marginBottom: 5,
            display: "flex",
        },
        body: {
            '@media only screen and (min-width: 480px)': {
                marginLeft: '4%',
                marginRight: '4%',
            },
            '@media only screen and (min-width: 1700px)': {
                marginLeft: '15%',
                marginRight: '15%',
            },
        },
        cardStyle: {
            opacity: 0.9,
            minHeight: 0,
            width: 95,
            height: 95,
            marginBottom: 5,
            textAlign: "center",
            '@media only screen and (max-width: 900px)': {
                width: 70,
                height: 70
            }
        },
        typography: {
            textAlign: "center",
            fontFamily: "Helvetica Neue",
            fontWeight: "bold",
            paddingBottom: 2,
            '@media only screen and (max-width: 900px)': {
                paddingBottom: 0,
                fontSize: 45,
                textAlign: "left"
            }
        },
        footerStyle: {
            position: "fixed",
            left: 0,
            bottom: 0,
            width: "100%",
            textAlign: "center"
        },
        label: {
            fontFamily: "Helvetica Neue",
            fontWeight: "bold",
            paddingBottom: 4,
        },
        divider: {
            marginTop: 4,
            marginBottom: 4
        },
        labelSmall: {
            paddingBottom: 3
        },
        bodyText: {
            fontFamily: "Helvetica Neue",
            paddingBottom: 4,
            marginTop: 1,
            '@media only screen and (max-width: 900px)': {
                paddingBottom: 2
            }
        },
        textInstruction: {
            paddingTop: 2
        },
        textPenalty: {
            textAlign: "center",
            paddingBottom: 1
        }
    }

    return (
        <Box>
            <SEO title="Services - Baliwag Municipal Library" description="RANIELLA VILLARAMA WEB DEVELOPER PORTFOLIO ... Services offered" />
            <Paper sx={style.background} elevation={0}>
                <Header />
                <Box sx={style.body}>
                    <Typography sx={style.typography} variant="h4" color="default"> Book Reservation</Typography>
                    <Stack direction="row" alignItems="center">
                        <ArticleOutlinedIcon sx={{ fontSize: 100 }} />
                        <Stack direction="column" sx={{ paddingTop: 3 }}>
                            <Typography variant='h5' sx={{ fontWeight: "bold" }}>Terms of Service</Typography>
                            <Typography sx={style.bodyText} variant="body1" color="default" align="justify">
                                The library, including its facilities and collection, is open to the public but in these difficult times we can now support online book reservations. Read and understand the terms thoroughly for a smoother transaction.
                            </Typography>
                        </Stack>
                    </Stack>

                    <Box sx={{ flexGrow: 1, paddingBottom: 4 }}>
                        <Grid container spacing={{ xs: 2, md: 3 }} columns={12}>
                            <Grid item sm={12} lg={6}>
                                <Card variant="outlined" sx={{ minHeight: 380, padding: 2 }}>
                                    <CardContent>
                                        <Typography variant="body2" sx={style.textInstruction}>
                                            Borrowing and returning of books should be fone only
                                            during the service hours (Monday to Thursday / 8:00 AM - 5:00 PM).
                                        </Typography>
                                        <Typography variant="body2" sx={style.textInstruction}>
                                            Sign in or create an account to reserve a book online. Pick the desired book
                                            from the collection and follow the indicated steps in the page to reserve it successfully.
                                            Pick-up details are to follow once your reservation is approved.
                                        </Typography>
                                        <Typography variant="body2" sx={style.textInstruction}>
                                            Library users who do not return the books on time will be considered as delinquent library users.
                                            Their Library ID will be confiscated and they will not be able to use the facility depending of the number of
                                            overdue days.
                                        </Typography>
                                        <Typography variant="body2" sx={style.textInstruction}>
                                            Library staff will contact delinquent users by phone. Library users who do not return
                                            the books after a month will be followed up through a home visit and will ask
                                            them to return the books immediately.
                                        </Typography>
                                    </CardContent>
                                </Card>
                            </Grid>
                            <Grid item sm={12} lg={6}>
                                <Card variant="outlined" sx={{ maxHeight: 380, padding: 2 }}>
                                    <CardContent >
                                        <Typography variant="body2" sx={{ ...style.textPenalty, fontWeight: "bold" }}>
                                            Prescribed Schedule of Penalty
                                        </Typography>
                                        <Grid container columns={12}>
                                            <Grid item xs={6}>
                                                <Typography variant="body2" sx={style.textPenalty}>
                                                    Number of Overdue Days
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={6}>
                                                <Typography variant="body2" sx={style.textPenalty}>
                                                    Penalty (Restriction to the use of Library)
                                                </Typography>
                                            </Grid>
                                            {Array.from(Constants.penaltyObject).map((_, index) => (
                                                <Grid item xs={12} key={index}>
                                                    <Divider sx={{ marginBottom: 1 }} />
                                                    <Grid container columns={12}>
                                                        <Grid item xs={6}>
                                                            <Typography variant="body2" sx={style.textPenalty}>
                                                                {Constants.penaltyObject[index].day}
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item xs={6}>
                                                            <Typography variant="body2" sx={style.textPenalty}>
                                                                {Constants.penaltyObject[index].penalty}
                                                            </Typography>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            ))}
                                        </Grid>
                                    </CardContent>
                                </Card>
                            </Grid>
                        </Grid>
                    </Box>
                </Box>
                <Box sx={{ height: 100 }} />
            </Paper>
            <Box sx={style.footerStyle}>
                <Footer />
            </Box>
        </Box>
    )
}
